import styled from 'styled-components'
import { typoHeading5 } from '../../../lib/styles/Typography'

export const Styled = {
  ItemTitle: styled.h3`
    ${typoHeading5}
  `,
  ItemDescription: styled.div`
    margin-top: 0.5rem;
  `,
}
